import { render, staticRenderFns } from "./AttendanceGrid.vue?vue&type=template&id=0be0ff4e"
import script from "./AttendanceGrid.vue?vue&type=script&lang=js"
export * from "./AttendanceGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports